export const WhiteList = ["Home", "About", "Login"];